export default __webpack_public_path__ + "static/media/5-years-logo.65edf3be.png";